import React from "react";
import { RouterProvider } from "react-router-dom";
import ContactChatIcon from "./Components/HomePage/ContactChatIcon";
import Router from "./Components/Router"; // Import the router from Router.js
function App() {
  return (
    <div>
      {/* <ScrollToTop /> */}
      <RouterProvider router={Router} />
      <ContactChatIcon />
    </div>
  );
}

export default App;
